var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMesCommandesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2143 0.384613C11.4863 0.384613 8.87013 1.4706 6.94119 3.40367C5.01224 5.33673 3.92857 7.95853 3.92857 10.6923H0.5L4.94571 15.1475L5.02571 15.3079L9.64286 10.6923H6.21429C6.21429 6.26 9.79143 2.67521 14.2143 2.67521C18.6371 2.67521 22.2143 6.26 22.2143 10.6923C22.2143 15.1246 18.6371 18.7094 14.2143 18.7094C12.0086 18.7094 10.0086 17.8046 8.56857 16.3501L6.94571 17.9764C7.89819 18.9362 9.03084 19.6975 10.2784 20.2164C11.5259 20.7354 12.8636 21.0017 14.2143 21C16.9422 21 19.5584 19.914 21.4874 17.9809C23.4163 16.0479 24.5 13.4261 24.5 10.6923C24.5 7.95853 23.4163 5.33673 21.4874 3.40367C19.5584 1.4706 16.9422 0.384613 14.2143 0.384613ZM13.0714 6.11111V11.8376L17.9286 14.7238L18.8086 13.2463L14.7857 10.8526V6.11111H13.0714Z",
    fill: "#676D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesCommandesIcon);
export default __webpack_public_path__ + "static/media/MesCommandesIcon.055e8871fed241363219b9ec736cddf2.svg";
export { ForwardRef as ReactComponent };